export const unstable_batchedUpdates = null;
export const ColorValue = {};
export const ViewStyle = {};
export const TouchableHighlightProps = {};
export const StyleProp = {};
export const ViewProps = {};
export const TextStyle = {};
export const PressableProps = {};
export const useDidShow = () => {};
export const useDidHide = () => {};
export default { useDidHide: useDidHide, useDidShow: useDidShow };



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/empty/index.js